import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useNavigate } from "react-router";
import FirebaseService from "../../firebase/FirebaseService";
import './login.scss';

export default function RecuperarSenha() {

    const [email, setEmail] = useState('');
    const [enviado, setEnviado] = useState(false);
    const [mensagem, setMensagem] = useState('');
    const navigate = useNavigate();

    function recuperar() {
        setMensagem('');
        const auth = FirebaseService.getApp().auth();
        auth.sendPasswordResetEmail(email).then(() => {
            setEnviado(true);
        }).catch(e => {
            console.warn(e);
            if (e.code === 'auth/invalid-email') {
                setMensagem('E-mail não é válido');
            } else if (e.code === 'auth/user-not-found') {
                setMensagem('E-mail não encontrado na base de dados');
            } else {
                setMensagem('Não foi possível realizar a recuperação de senha');
            }
        });
    }

    return (
        <div className="login">
            <div className="login-center">
                <div className="row">
                    <div className="col-sm-12">
                        <img src='/empx.png' className="login-img-logo" alt="logo" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <span style={{ fontWeight: 'bold', color: 'red' }}>{mensagem}</span>
                    </div>
                </div>
                {!enviado ? (
                    <>
                        <div className="row">
                            <div className="col-sm-12">
                                <span style={{ fontWeight: 'bold' }}>Digite seu e-mail para recuperar a senha</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <InputText style={{ width: 300, textAlign: 'center' }} className="login-input" autoFocus={true} type="email" id="email" name="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <Button className='login-botao' label="Recuperar" onClick={() => recuperar()} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <a href='/'>Voltar para o login</a>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="row">
                            <div className="col-sm-12">
                                <span style={{ fontWeight: 'bold' }}>Foi enviado um e-mail com as instruções para recuperar a senha</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <a href='/'>Voltar para o login</a>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div >
    )
}